import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Shield } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SuperuserLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/superuser/login`, formData);
      
      // Store token and user info
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      
      toast.success("Login successful!");
      navigate("/superuser/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-zinc-50 to-zinc-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl border border-zinc-200">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-lime-400 rounded-full flex items-center justify-center mb-4">
            <Shield size={32} className="text-zinc-900" />
          </div>
          <h1 className="text-3xl font-black tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
            Superuser Login
          </h1>
          <p className="text-zinc-500 text-sm mt-2">Access restricted to system administrators</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="superadmin@gymapp.com"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-lime-400 text-zinc-900 hover:bg-lime-500 font-bold"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login as Superuser"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SuperuserLogin;